/**
* Create the animation configs using the width of screen
* Total Slides - 3 - Slide-2 hover
*/
export const X3Slide1 = (width) => {
    return [
        {
            width: "63%",
            x: `-${width * 0.63 * 3}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "63%",
            x: `-${width * 0.63 * 2}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "63%",
            x: `-${width * 0.63}px`,
            zIndex: 0,
            opacity: 1
        },
        {
            width: "75%",
            x: `-${width * 0.1}px`, 
            zIndex: 1,
            opacity: 1
        },
        {
            width: "33%",
            x: `${width * 0.62}px`, 
            zIndex: 20,
            opacity: 1
        },
        {
            width: "28%",
            x: `${width * 0.85}px`, 
            zIndex: 21,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 1}px`,
            zIndex: 0,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 1.16}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "26%",
            x: `${width * 1.32}px`,
            zIndex: 0,
            opacity: 0
        }
    ]
};

/*
* Total Slides - 3 Slide-3 hover
*/
export const X3Slide2 = (width) => {
    return [
        {
            width: "63%",
            x: `-${width * 0.63 * 3}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "63%",
            x: `-${width * 0.63 * 2}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "63%",
            x: `-${width * 0.63}px`,
            zIndex: 0,
            opacity: 1
        },
        {
            width: "75%",
            x: `-${width * 0.1}px`, 
            zIndex: 1,
            opacity: 1
        },
        {
            width: "33%",
            x: `${width * 0.60}px`,
            zIndex: 20,
            opacity: 1
        },
        {
            width: "28%",
            x: `${width * 0.83}px`,
            zIndex: 21,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 1}px`,
            zIndex: 0,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 1.16}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "26%",
            x: `${width * 1.32}px`,
            zIndex: 0,
            opacity: 0
        }
    ]
};

/**
* Create the animation configs using the width of screen
*/
export const X2slide1 = (width) => {
    return [
        {
            width: '80%',
            x: `-${width * 1.6}px`,
            zIndex: 1,
            opacity: 0,
        },
        {
            width: '80%',
            x: `-${width * 0.8}px`,
            zIndex: 1,
            opacity: 1
        },
        {
            width: '80%',
            x: `-${width * 0.02}px`, 
            zIndex: 20,
            opacity: 1
        },
        {
            width: "33%",
            x: `${width * 0.78}px`,
            zIndex: 21,
            opacity: 1
        },
        {
            width: "31%",
            x: `${width * 1}px`,
            zIndex: 1,
            opacity: 1
        },
        {
            width: "31%",
            x: `${width * 1.21}px`,
            zIndex: 1,
            opacity: 0
        }
    ]
};
